<template>
  <div v-if="onboarding">
    <OnbordingLE v-if="$store.state.admin.storeId == '33'" />
    <OnbordingDADA v-else-if="$store.state.admin.storeId == '26'" />
  </div>
</template>

<script>
import OnbordingLE from "./onbording/LE/View.vue";
import OnbordingDADA from "./onbording/DADA/View.vue";
export default {
  name: "Onboarding",
  components: {
    OnbordingLE,
    OnbordingDADA,
  },
  data() {
    return {};
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
  },
};
</script>
